
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { CheckboxChoicesOptions } from "@/model/pagePartOptions/CheckboxChoicesOptions";
    import { VisitAnswer } from "@/model/VisitAnswer";
    import { QuestionTextLayout } from "@/model/Enums";

    @Component({})
    export default class CheckboxChoicesPart extends Vue {

        // mounted(): void {
        //     console.log("+++ CheckboxChoicesPart options=", this.options);
        //     console.log("+++ CheckboxChoicesPart answer=", this.answer);
        // }
        
        @Prop({ default: new CheckboxChoicesOptions() })
        options!: CheckboxChoicesOptions;

        @Prop({ default: null })
        answer!: VisitAnswer|null;
        
        @Prop({ default: false })
        isAdminView!: boolean;

        get isQuestionAbove(): boolean {
            return this.options.layoutType === QuestionTextLayout.QuestionAbove
            || this.options.layoutType === QuestionTextLayout.Default;
        }

        get isQuestionleft(): boolean {
            return this.options.layoutType === QuestionTextLayout.QuestionOnLeft;
        }

        isChecked(index: number): boolean {
            if(this.answer == null) return false;
            const indeces = this.getArrayOfSelectedIndeces(this.answer.givenAnswer);
            return indeces.indexOf(index) > -1;
        }

        onCheckedChanged(index: number, isChecked: boolean) {
            if(this.answer == null) return;
            const answer = this.options.choices[index];
            let answers = this.answer?.givenAnswer?.split("|").filter(a => !!a);
            const isCheckedAlready = answers.indexOf(answer) > -1;
            if(isCheckedAlready && !isChecked) {
                answers = answers.filter(a => a !== answer);
            }
            if(!isCheckedAlready && isChecked) {
                answers.push(answer);
            }
            const answersText = answers.join("|");
            const selectedChoiceIndeces = this.getArrayOfSelectedIndeces(answersText);
            this.$emit("answer-changed", selectedChoiceIndeces, this.answer?.pagePartID ?? 0, answersText);
        }

        getArrayOfSelectedIndeces(answersText: string): Array<number> {
            const indeces: Array<number> = [];
            if(!answersText) return indeces;
            const answers = answersText.split("|");
            let i = 0;
            for(const choice of this.options.choices) {
                if(answers.indexOf(choice) > -1) indeces.push(i);
                i++;
            }
            return indeces;
        }

        get correctChoiceTexts(): Array<string> { 
            if(!this.isAdminView) return [];
            const texts: Array<string> = [];
            let i = 0;
            for(const choice of this.options.choices) {
                if(this.options.correctIndeces.indexOf(i) > -1) texts.push(choice)
                i++;
            }
            return texts;
         }

    }
